import ProgressBar from "react-bootstrap/ProgressBar";

const ProgressBarLabel = ({ now }) => {
  return <ProgressBar now={now} label={`${now}%`} />;
};

export default ProgressBarLabel;
